import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-scroll';
import PortfolioContext from '../../context/context';

const Header = () => {
  const { hero } = useContext(PortfolioContext);
  const { title, name, subtitle, cta } = hero;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="hero" className="jumbotron">
      <Container>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
          <section className="hero-content">
            <div>
              <h1 className="hero-title">
                {title} <span className="text-color-main">{name}</span>
                <br />
              </h1>
              <h2
                className="hero-title hero-subtitle"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />
            </div>

            <div>
              <img
                className="hero-img"
                src="https://i.ibb.co/wW9nw5m/2823496-removebg-preview.png"
                alt="women programmer"
                border="0"
              />
            </div>
          </section>
        </Fade>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
          <p className="hero-cta">
            <span className="cta-btn cta-btn--hero">
              <Link to="about" smooth duration={1000}>
                {cta || 'Learn more'}
              </Link>
            </span>
          </p>
        </Fade>
      </Container>
    </section>
  );
};

export default Header;
